import { Navigate, Outlet, useLocation } from "react-router-dom";

import { Spinner } from "@krea/shared/design-system/Spinner";
import { useAuthStore } from "@krea/shared/features/auth/authStore";

import type { LenderUserRoleEnum } from "@/features/common/enums";
import { useGetCurrentLenderCompanyQuery } from "@/features/lender-companies/hooks/use-get-lender-company.query";
import { useGetMeQuery } from "@/features/users/hooks/use-get-me.query";

export const PrivateRoute = ({
  rolesWithAccess = null,
}: {
  rolesWithAccess?: LenderUserRoleEnum[] | null;
}) => {
  const location = useLocation();
  const { data: me, isPending } = useGetMeQuery();
  const { data: lenderCompany } = useGetCurrentLenderCompanyQuery();
  const accessToken = useAuthStore((state) => state.accessToken);
  const isAuthenticated = !!me?.id || !!accessToken;

  if (isPending) {
    return (
      <div className="flex h-full flex-col items-center justify-center">
        <Spinner className="text-primary" size="xl" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to={{
          pathname: "/login",
        }}
        state={{ from: location }}
      />
    );
  }

  const hasAccess =
    me?.isAdmin ||
    (lenderCompany?.userSettings?.role &&
      rolesWithAccess?.includes(lenderCompany.userSettings.role));

  if (rolesWithAccess && !hasAccess) {
    return (
      <Navigate
        to={{
          pathname: "/",
        }}
        state={{ from: location }}
      />
    );
  }

  return <Outlet />;
};
